let zuqoSlickPromise;
const zuqoScriptTag = document.currentScript;
function ensureZuqoSlick() {
  if ($.fn.slick) return Promise.resolve();
  if (!zuqoSlickPromise) zuqoSlickPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = zuqoScriptTag.dataset.slickUrl;
    script.onload = resolve;
    script.onerror = () => { zuqoSlickPromise = null; reject(new Error('Carousel script unavailable')); };
    document.head.appendChild(script);
  });
  return zuqoSlickPromise;
}
function scheduleZuqoSliders() {
  document.querySelectorAll('.slider-items, .product-contents-slider, .collection-item-slider').forEach((slider) => {
    if (slider.dataset.zuqoObserved) return;
    slider.dataset.zuqoObserved = 'true';
    const init = () => ensureZuqoSlick().then(() => { hero_slider(); product_slider(); collection_item_slider(); }).catch(() => {});
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        const visible = entries[0].isIntersecting;
        slider.dataset.zuqoCarouselVisible = String(visible);
        if (visible) init();
        if ($.fn.slick && slider.classList.contains('slick-initialized') && $(slider).slick('getSlick').options.autoplay) $(slider).slick(visible ? 'slickPlay' : 'slickPause');
      }, { rootMargin: '0px' }).observe(slider);
    } else init();
  });
}
document.addEventListener('pointerover', hydrateZuqoHover);
document.addEventListener('focusin', hydrateZuqoHover);
function hydrateZuqoHover(event) {
  if (!window.matchMedia('(hover: hover)').matches || !(event.target instanceof Element)) return;
  const link = event.target.closest('.product-card-link');
  const template = link?.querySelector('template[data-zuqo-hover-image]');
  if (!template) return;
  const fragment = template.content.cloneNode(true);
  const image = fragment.querySelector('img');
  if (!image) return;
  const markReady = () => {
    if (image.naturalWidth > 0) link.classList.add('zuqo-hover-ready');
  };
  image.loading = 'eager';
  image.addEventListener('load', markReady, { once: true });
  image.addEventListener('error', () => link.classList.remove('zuqo-hover-ready'), { once: true });
  template.replaceWith(fragment);
  if (image.complete) markReady();
}

// hero slider 
$(document).ready(function(){
    scheduleZuqoSliders();

    // product tab 
    $('.product-tab-item').on('click', function(){
        var id = $(this).data('id');
        $(this).addClass('active').siblings().removeClass('active');
        $('#tab_'+id).addClass('show').siblings().removeClass('show');
        ensureZuqoSlick().then(function(){ product_slider(); $('.product-contents-slider.slick-initialized').slick('setPosition'); }).catch(() => {});
    })

    // size guide 
    $('span.size-quide-btn').on('click', function(){
        $('.size-quide').fadeIn();
    })

    $('.size-guide-close, .size-guide-overly').on('click', function(){
        $('.size-quide').fadeOut();
    })

    // cart dreawer 
    $('.header_cart').on('click', function(e){
        e.preventDefault();
        $('body').addClass('cartshown');
        ensureZuqoSlick().then(upsell_slider).catch(() => {});
    })
    $('.cart-drawer-close, .cart-drawer-overly').on('click', function(){
        $('body').removeClass('cartshown');
    })
})

document.addEventListener('shopify:section:load', scheduleZuqoSliders);

function hero_slider() {
    if (!$.fn.slick) return;
    $('.slider-items:not(.slick-initialized)').filter(function(){ const r=this.getBoundingClientRect(); return r.width > 0 && r.bottom > -200 && r.top < innerHeight + 200; }).slick({ 
        speed:300,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows:true,
        dots:true,
        prevArrow:"<span type='button' class='arrow-prev'><img src='"+ arrow +"' alt='arrow' width='24' height='24'></span>",
        nextArrow:"<span type='button' class='arrow-next'><img src='"+ arrow +"' alt='arrow' width='24' height='24'></span>"
    }); 
}
// upsell slider 
function upsell_slider() {
    if (!$.fn.slick) return;
    $('.drawer-upsell-items:not(.slick-initialized)').slick({ 
        speed:300,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        arrows:true,
        dots:false,
        prevArrow:"<span type='button' class='arrow-prev'><img src='"+ arrow +"' alt='arrow' width='24' height='24'></span>",
        nextArrow:"<span type='button' class='arrow-next'><img src='"+ arrow +"' alt='arrow' width='24' height='24'></span>"
    }); 
}
// upsell slider 
function collection_item_slider() {
    if (!$.fn.slick) return;
    $('.collection-item-slider:not(.slick-initialized)').filter(function(){ const r=this.getBoundingClientRect(); return r.width > 0 && r.bottom > -200 && r.top < innerHeight + 200; }).slick({ 
        infinite: true,
        autoplay: !window.matchMedia('(max-width: 749px), (prefers-reduced-motion: reduce)').matches,
        autoplaySpeed: 3200,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow:"<span type='button' class='product-arrow-prev'><img src='"+ arrow +"' alt='arrow' width='24' height='24'></span>",
        nextArrow:"<span type='button' class='product-arrow-next'><img src='"+ arrow +"' alt='arrow' width='24' height='24'></span>",
        dots:false,
        responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
              }
            }
        ]
    }).each(function() {
        if (this.dataset.zuqoCarouselVisible === 'false') $(this).slick('slickPause');
    }); 
}

// product tab with slider 
function product_slider() {
    if (!$.fn.slick) return;
    var reduceContinuousMotion = document.documentElement.classList.contains('zuqo-android') ||
        window.matchMedia('(max-width: 749px), (prefers-reduced-motion: reduce)').matches;
    $('.product-contents-slider:not(.slick-initialized)').filter(function(){ const r=this.getBoundingClientRect(); return r.width > 0 && r.bottom > -200 && r.top < innerHeight + 200; }).slick({
        infinite: true,
        autoplay: !reduceContinuousMotion,
        autoplaySpeed: 0,
        speed: reduceContinuousMotion ? 180 : 6000,
        cssEase: 'linear',
        waitForAnimate: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        swipeToSlide: true,
        touchThreshold: 12,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow:"<span type='button' class='product-arrow-prev'><img src='"+ arrow +"' alt='arrow' width='24' height='24'></span>",
        nextArrow:"<span type='button' class='product-arrow-next'><img src='"+ arrow +"' alt='arrow' width='24' height='24'></span>",
        dots:false,
        responsive: [
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2.12,
                slidesToScroll: 1,
                infinite: true,
                arrows: false
              }
            }
          ]
    }).each(function() {
        if (this.dataset.zuqoCarouselVisible === 'false') $(this).slick('slickPause');
    })
    // .on('setPosition', function (event, slick) {
    //     slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    // });
}

// product tab in single page 
var el = document.querySelectorAll('ul.info-tab-items li');
var contents = document.querySelectorAll('.product-info-tab-contents .info-tab-content');
for (let i = 0; i < el.length; i++) {
  el[i].onclick = function() {
    var c = 0;
    while (c < el.length) {
      el[c++].className = 'info-tab-item';
    }
    el[i].className = 'info-tab-item active';
    var id = this.getAttribute('data-id');
    var d = 0;
    while (d < contents.length) {
        contents[d++].className = 'info-tab-content';
        if(id == d) {
            contents[i].className = 'info-tab-content show';
        }
    }
  };
}

// cart item update 
function cart_item_update() {
    fetch('/?section_id=cart-drawer')
        .then(reponse => reponse.text())
        .then(cartData => {
            var cart_html = $(cartData);
            var cart_items = $('.cart-drawer-items', cart_html);
            var cart_footer = $('.cart-footer-content', cart_html);
            var cart_progress = $('.cart-progress', cart_html);
            $('.cart-drawer-items').replaceWith(cart_items);
            $('.cart-footer-content').replaceWith(cart_footer);
            $('.cart-progress').replaceWith(cart_progress);
    });

    $.getJSON('/cart.js', function(cart){
        var total_items = cart.item_count;
        $('.cart-count-bubble span').text(total_items);
    })
}
